'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _functional = require('../../utils/functional');

var _QuizSlide = require('./QuizSlide');

var _QuizSlide2 = _interopRequireDefault(_QuizSlide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Quiz',

  data: function data() {
    return {
      footer: (0, _functional.getElement)('#shopify-section-footer')
    };
  },
  created: function created() {
    this.footer.style.display = 'none';
  },
  mounted: function mounted() {
    this.$refs.slides.style.width = 100 * (this.$refs.slide.length + 1) + 'vw';
  },


  computed: Object.assign({}, (0, _vuex.mapGetters)(['finalAnswer', 'questions', 'activeSlideIndex', 'quizFinished'])),

  watch: {
    quizFinished: function quizFinished(val) {
      if (val) {
        this.footer.style.display = '';
      }
    }
  },

  components: {
    QuizSlide: _QuizSlide2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//